module.exports = __webpack_public_path__ + "img/itx-arrow-last.aace5e9a.svg";